import {
  Dialog,
  DialogTitle,
  DialogContentText,
  DialogContent,
} from "@material-ui/core";
import { CircularProgress } from "@material-ui/core";
import FormikTextField from "../../../Common/FormFields/FormikInputField";
import setnewimg from "../../../assets/images/setnewimg.png";
import validationSchema from "../../../Validation/ValidationSchemas";
import { Formik, Form } from "formik";
import { FaTimes } from "react-icons/fa";
const ResetPasswordDialog = ({
  submitResetPassword,
  openReset,
  handleToCloseReset,
}) => {
  return (
    <Dialog open={openReset} onClose={handleToCloseReset} id="ResetPass">
      <DialogTitle>
        <div className="d-flex-space-between">
          <div className="d-flex-align-cent">
            <img src={setnewimg} alt="img"></img>
            <label className="fs-18 semibold pl-3 mg-bottom-0">
              Reset Password
            </label>
          </div>
          <FaTimes onClick={handleToCloseReset} className="crossview cp" />
        </div>
      </DialogTitle>
      <hr className="mt-0 mb-0"></hr>
      <DialogContent>
        <DialogContentText>
          <Formik
            initialValues={{
              oldPassword: "",
              password: "",
              confirmPassword: "",
            }}
            validationSchema={validationSchema.resetPasswordSchema}
            onSubmit={(values, { setSubmitting }) => {
              submitResetPassword(values, setSubmitting);
            }}
          >
            {(formik) => (
              <Form className="form-container">
                <FormikTextField
                  label="CURRENT PASSWORD"
                  formik={formik}
                  fieldName="oldPassword"
                  placeholder="Current Password"
                  labelFontSize="fs-18"
                  type="password"
                  customClassNames="formik-input-field instn fs-18 semi-bold w-100 olnone share-popup-input fmlabel black "
                />
                <FormikTextField
                  label="NEW PASSWORD"
                  formik={formik}
                  fieldName="password"
                  placeholder="New Password"
                  labelFontSize="fs-18"
                  type="password"
                  customClassNames="formik-input-field instn fs-18 semi-bold w-100 olnone share-popup-input fmlabel black "
                />
                <FormikTextField
                  label="CONFIRM NEW PASSWORD"
                  formik={formik}
                  fieldName="confirmPassword"
                  placeholder="Confirm New Password"
                  labelFontSize="fs-18"
                  type="password"
                  customClassNames="formik-input-field instn fs-18 semi-bold w-100 olnone share-popup-input fmlabel black "
                />
                <button
                  type="submit"
                  className="submit-btnblue fs-24 regular white w-100"
                  disabled={formik.isSubmitting}
                >
                  {formik.isSubmitting ? "Updating..." : "Update Password"}
                </button>
                {formik.isSubmitting && (
                  <CircularProgress className="circle-mark" color="secondary" />
                )}
              </Form>
            )}
          </Formik>
          <div className="clear20"></div>
        </DialogContentText>
      </DialogContent>
      <div className="clear20"></div>
    </Dialog>
  );
};

export default ResetPasswordDialog;
